module.exports = __webpack_public_path__ + "static/img/punto_5.3f7f3d3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/punto_5.jpeg
// module id = j7WN
// module chunks = 2